var _excluded = ["dropdownList", "dropdownRefs"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useEffect, useState } from "react";
import IsDarkModeContext from "../../../../../../../contexts/IsDarkModeContext";
import { KeyboardEventKeys } from "../../../../../../../typings/types";
import { DispatchContext, StateContext } from "../../../../contexts";
import { ActionType } from "../../../../reducers/mainReducer";
import NavigationDropdownContentOrg from "./NavigationDropdownContentOrg";
import { Container, Content } from "./NavigationDropdownOrg.styled";
function NavigationDropdownOrg(_ref) {
  var dropdownList = _ref.dropdownList,
    dropdownRefs = _ref.dropdownRefs,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var dispatch = useContext(DispatchContext);
  var _useContext = useContext(StateContext),
    navigationIndex = _useContext.navigationIndex,
    desktopDropdown = _useContext.desktopDropdown,
    isNavigationActive = _useContext.isNavigationActive;
  var isOpenMobileMenu = isNavigationActive && desktopDropdown === null;
  var isOpenMobileDropdown = isOpenMobileMenu && navigationIndex !== null;
  var isDarkMode = useContext(IsDarkModeContext);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isFirstAppear = _useState2[0],
    setIsFirstAppear = _useState2[1];
  useEffect(function () {
    setIsFirstAppear(navigationIndex === null);
  }, [navigationIndex]);
  useEffect(function () {
    var handleDocumentKeyDownMobileMenu = function handleDocumentKeyDownMobileMenu(event) {
      if (event.key === KeyboardEventKeys.ESC && isOpenMobileMenu) {
        dispatch({
          type: ActionType.SET_NAVIGATION_INACTIVE
        });
      }
      if (event.key === KeyboardEventKeys.ESC && isOpenMobileDropdown) {
        dispatch({
          type: ActionType.SET_NAVIGATION_ACTIVE,
          navigationIndex: null,
          markerLeftPosition: null,
          desktopDropdown: null
        });
        dispatch({
          type: ActionType.SET_NAVIGATION_LIST_FOCUS,
          navigationListFocusIndex: navigationIndex + 1
        });
      }
    };
    if (isOpenMobileMenu) {
      document.addEventListener("keydown", function (event) {
        return handleDocumentKeyDownMobileMenu(event);
      });
    }
    return function () {
      if (isOpenMobileMenu) {
        document.removeEventListener("keydown", function (event) {
          return handleDocumentKeyDownMobileMenu(event);
        });
      }
    };
  }, [isOpenMobileMenu, isOpenMobileDropdown]);
  return /*#__PURE__*/React.createElement(Container, _extends({
    $width: desktopDropdown === null || desktopDropdown === void 0 ? void 0 : desktopDropdown.width,
    $height: desktopDropdown === null || desktopDropdown === void 0 ? void 0 : desktopDropdown.height,
    $placement: desktopDropdown === null || desktopDropdown === void 0 ? void 0 : desktopDropdown.placement,
    $asideHeight: desktopDropdown === null || desktopDropdown === void 0 ? void 0 : desktopDropdown.asideHeight,
    $isActive: navigationIndex !== null && desktopDropdown !== null,
    $isDarkMode: isDarkMode
  }, restProps), dropdownList.map(function (_ref2) {
    var index = _ref2.index,
      title = _ref2.title,
      links = _ref2.links,
      additionalLink = _ref2.additionalLink,
      asideLinks = _ref2.asideLinks;
    return /*#__PURE__*/React.createElement(Content, {
      ref: function ref(_ref3) {
        if (_ref3) {
          // eslint-disable-next-line no-param-reassign
          dropdownRefs.current[index] = _ref3;
        }
      },
      key: title,
      $isActive: navigationIndex === index,
      $isFirstAppear: isFirstAppear
    }, /*#__PURE__*/React.createElement(NavigationDropdownContentOrg, {
      title: title,
      links: links,
      additionalLink: additionalLink,
      asideLinks: asideLinks
    }));
  }));
}
export default NavigationDropdownOrg;